import { jsx, jsxs } from 'react/jsx-runtime';
import { AlertDialogOverlay as AlertDialogOverlay$1, AlertDialogPortal as AlertDialogPortal$1, AlertDialogContent as AlertDialogContent$1, AlertDialogTitle as AlertDialogTitle$1, AlertDialogDescription as AlertDialogDescription$1, Action as AlertDialogAction$1, AlertDialogCancel as AlertDialogCancel$1, AlertDialog as AlertDialog$1, AlertDialogTrigger as AlertDialogTrigger$1 } from '../../vendor/@radix-ui/react-alert-dialog/dist/index.mjs';
import * as React from 'react';
import { buttonVariants } from './button.js';
import { cn } from '../../lib/utils.js';

const AlertDialog = AlertDialog$1;
const AlertDialogTrigger = AlertDialogTrigger$1;
const AlertDialogPortal = AlertDialogPortal$1;
const AlertDialogOverlay = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AlertDialogOverlay$1,
  {
    className: cn(
      "fixed inset-0 z-[999999] bg-black/60 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      className
    ),
    ...props,
    ref
  }
));
AlertDialogOverlay.displayName = AlertDialogOverlay$1.displayName;
const AlertDialogContent = React.forwardRef(({ className, ...props }, ref) => {
  const contentRef = React.useRef(null);
  const setRefs = React.useCallback(
    (node) => {
      contentRef.current = node;
      if (typeof ref === "function") {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    },
    [ref]
  );
  return /* @__PURE__ */ jsxs(AlertDialogPortal, { children: [
    /* @__PURE__ */ jsx(AlertDialogOverlay, {}),
    /* @__PURE__ */ jsx(
      AlertDialogContent$1,
      {
        onOpenAutoFocus: (e) => {
          e.preventDefault();
          contentRef?.current?.focus();
        },
        ref: setRefs,
        className: cn(
          "dialog-content fixed left-[50%] top-[50%] z-[999999] grid w-full max-w-[90%] md:max-w-[380px] translate-x-[-50%] translate-y-[-50%] border bg-base-white shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] rounded-[24px] outline-none focus:outline-none",
          className
        ),
        ...props
      }
    )
  ] });
});
AlertDialogContent.displayName = AlertDialogContent$1.displayName;
const AlertDialogHeader = ({ className, ...props }) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn("flex flex-col text-center overflow-auto max-h-[480px]", className),
    ...props
  }
);
AlertDialogHeader.displayName = "AlertDialogHeader";
const AlertDialogFooter = ({ className, ...props }) => /* @__PURE__ */ jsx("div", { className: cn("flex flex-row items-center justify-center w-full", className), ...props });
AlertDialogFooter.displayName = "AlertDialogFooter";
const AlertDialogTitle = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AlertDialogTitle$1,
  {
    ref,
    className: cn("pb-4 text-center heading-h5 font-weight-bold ", className),
    ...props
  }
));
AlertDialogTitle.displayName = AlertDialogTitle$1.displayName;
const AlertDialogDescription = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AlertDialogDescription$1,
  {
    ref,
    className: cn("body-lg text-basic-02 !mt-0", className),
    ...props
  }
));
AlertDialogDescription.displayName = AlertDialogDescription$1.displayName;
const AlertDialogAction = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AlertDialogAction$1,
  {
    ref,
    className: cn(
      buttonVariants({ variant: "line" }),
      "text-primary-04 py-[18px] h-auto",
      className
    ),
    ...props
  }
));
AlertDialogAction.displayName = AlertDialogAction$1.displayName;
const AlertDialogCancel = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  AlertDialogCancel$1,
  {
    ref,
    className: cn(
      buttonVariants({ variant: "line" }),
      "text-basic-04 py-[18px] h-auto border-r border-basic-04",
      className
    ),
    ...props
  }
));
AlertDialogCancel.displayName = AlertDialogCancel$1.displayName;

export { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertDialogPortal, AlertDialogTitle, AlertDialogTrigger };
